<template lang="html">

  <section class="home-empresa row-between container ais">

    <div class="contenedor-left">

      <!-- <div class="contenedor-home container row-between ais">

        <article class="home-el" v-if="!!procesos" title="Número de ofertas publicadas en este momento">

          <router-link :to="$t('enlaces.mis_ofertas')+'/practicas'" class="enlace-cover"></router-link>

          <h3 v-html="$t('home_empresa.ofertas_practicas')"></h3>

          <p v-html="$t('home_empresa.texto_ofertas_practicas')"></p>

          <h4 class="bubble" :loading="loading" title="Número de ofertas publicadas en este momento">
            <template v-if="procesosPracticasActivos!= '0'">{{procesosPracticasActivos}}</template>
<template v-else>0</template>
</h4>

</article>

<article class="home-el">

  <router-link :to="$t('enlaces.nueva_oferta')+'/practicas'" class="enlace-cover"></router-link>

  <h3 v-html="$t('home_empresa.nueva_practicas')"></h3>

  <p v-html="$t('home_empresa.publicar_practicas')"></p>

  <h4 class="bubble add">+</h4>


</article>

<template v-if="brand.ofertasEmpleo">
          <article class="home-el" v-if="!!procesos" title="Número de ofertas publicadas en este momento">

            <router-link :to="$t('enlaces.mis_ofertas')+'/empleo'" class="enlace-cover"></router-link>

            <h3 v-html="$t('home_empresa.ofertas_empleo')"></h3>

            <p v-html="$t('home_empresa.texto_ofertas_empleo')"></p>
            <h4 class="bubble" :loading="loading" title="Número de ofertas publicadas en este momento">
              <template v-if="procesosEmpleoActivos!= '0'">{{procesosEmpleoActivos}}</template>
<template v-else>0</template>
</h4>
</article>

<article class="home-el">

  <router-link :to="$t('enlaces.nueva_oferta')+'/empleo'" class="enlace-cover"></router-link>

  <h3 v-html="$t('home_empresa.nueva_empleo')"></h3>

  <p v-html="$t('home_empresa.texto_nueva_empleo')"></p>

  <h4 class="bubble add">+</h4>

</article>
</template>
</div> -->
      <div class="container-offers">
        <article>
          <div class="content-top -practicas">
            <span>{{ brand.inactiveOfertasPracticas ? $t('header.proximamente') : procesosPracticasActivos + ' ofertas publicadas' }}</span>
            <h3>Ofertas de prácticas</h3>
            <p>Consulta y gestiona las ofertas de prácticas y las candidaturas recibidas.</p>
            <router-link :to="$t('enlaces.mis_ofertas') + '/practicas'" v-if="!brand.inactiveOfertasPracticas">Acceder a todas las ofertas </router-link>
          </div>
          <div class="content-bottom">
            <span class="main" v-if="brand.inactiveOfertasPracticas" :class="{'tooltip-disabled': brand.inactiveOfertasPracticas}" :text-tooltip="$t('header.proximamente')">Nueva oferta de práctica</span>
            <router-link v-else :to="$t('enlaces.nueva_oferta') + '/practicas'">Nueva oferta de prácticas </router-link>
            <p>Publica ofertas de prácticas, dirigidas a nuestros estudiantes.</p>
          </div>
        </article>
        <article>
          <div class="content-top -empleo">
            <span>{{ procesosEmpleoActivos }} ofertas publicadas</span>
            <h3>Ofertas de empleo</h3>
            <p>Consulta y gestiona las ofertas de empleo y las candidaturas recibidas.</p>
            <router-link :to="$t('enlaces.mis_ofertas') + '/empleo'">Acceder a todas las ofertas </router-link>
          </div>
          <div class="content-bottom">
            <router-link :to="$t('enlaces.nueva_oferta') + '/empleo'">Nueva oferta de empleo </router-link>
            <p>Publica ofertas de empleo, dirigidas a nuestros titulados.</p>
          </div>
        </article>
      </div>

      <div class="contenedor-encuestas">
        <modulo-encuestas></modulo-encuestas>
      </div>

      <div class="-comunicaciones" v-if="comunicaciones.length > 0">
        <div class="contenedor-modulo-comunicaciones" v-if="comunicaciones.length > 0">
          <modulo-comunicaciones></modulo-comunicaciones>
        </div>
      </div>

    </div>


  </section>

</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';

import moduloEncuestas from '@/components/views/home/modulo-encuestas'

import moduloComunicaciones from './modulo-comunicaciones';

export default {
  name: 'home-empresa',
  mounted() {
    this.requestNumProcesos();
  },
  components: {
    'modulo-encuestas': moduloEncuestas,
    'modulo-comunicaciones': moduloComunicaciones,
  },
  methods: {
    ...mapActions(['requestNumProcesos']),
  },
  computed: {
    ...mapGetters({
      colors: 'basicColors',
      style: 'getStyles',
      procesos: 'getNumProcesos',
      comunicaciones: 'getComunicaciones',
      brand: 'getBrand',
      loading: 'getLoadingProcesos'
    }),
    procesosPracticasActivos: function () {
      let procesos
      if (!!this.procesos) {
        procesos = this.procesos.numProcesosActivosPracticas
      }
      return procesos;
    },
    procesosEmpleoActivos: function () {
      let procesos
      if (this.brand.agenciaColocacion) {
        if (!!this.procesos) {
          procesos = this.procesos.numProcesosActivosCandidatos
        }
      } else {
        if (!!this.procesos) {
          procesos = this.procesos.numProcesosActivosEmpleo
        }
      }
      return procesos;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/home/home-empresa.vue